'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _nhl_fetchHelpers = require('@nhl/fetch-helpers');
var Cookies = _interopDefault(require('cookies-js'));

var asyncToGenerator = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

var StateContainer = function StateContainer() {
    this.authCookieName = null;
    this.authCookieDomain = null;
    this.pingUrl = null;
    this.isAccountApp;
};

StateContainer.prototype.init = function (authCookieName, authCookieDomain, pingUrl) {
    var isAccountApp = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    this.authCookieName = authCookieName;
    this.authCookieDomain = authCookieDomain;
    this.pingUrl = pingUrl;
    this.isAccountApp = isAccountApp;
};

var checkAuthState = function () {
    var _ref = asyncToGenerator(regeneratorRuntime.mark(function _callee(stateContainer, callback) {
        var authToken, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (!stateContainer.authCookieName) {
                            _context.next = 16;
                            break;
                        }

                        authToken = getAuthToken(stateContainer);
                        _context.prev = 2;
                        _context.next = 5;
                        return fetch(stateContainer.pingUrl || '/site/api/component-season', {
                            method: 'HEAD',
                            headers: {
                                authorization: (stateContainer.isAccountApp ? 'Bearer' : 'BEARER') + ' ' + authToken
                            }
                        });

                    case 5:
                        response = _context.sent;


                        _nhl_fetchHelpers.checkStatus(response);
                        return _context.abrupt('return', true);

                    case 10:
                        _context.prev = 10;
                        _context.t0 = _context['catch'](2);

                        if (_context.t0 instanceof _nhl_fetchHelpers.FetchError && _context.t0.status === 401) {
                            logout(stateContainer);
                        }
                        return _context.abrupt('return', false);

                    case 14:
                        _context.next = 17;
                        break;

                    case 16:
                        console.error('Attempted to call checkAuthState() without setting the auth cookie name! Be sure to call init first!');

                    case 17:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this, [[2, 10]]);
    }));

    return function checkAuthState(_x2, _x3) {
        return _ref.apply(this, arguments);
    };
}();

var logout = function logout(stateContainer) {
    if (stateContainer.authCookieName && stateContainer.authCookieDomain) {
        Cookies.expire(stateContainer.authCookieName, {
            domain: stateContainer.authCookieDomain
        });
    } else {
        console.error('Attempted to call logout() without setting the auth cookie name and domain! Be sure to call init first!');
    }
};

var getAuthToken = function getAuthToken(stateContainer) {
    if (stateContainer.authCookieName) {
        var cookieValue = Cookies.get(stateContainer.authCookieName);
        return stateContainer.isAccountApp && cookieValue ? 'u:' + atob(cookieValue) : cookieValue;
    } else {
        console.error('Attempted to call checkAuthState() without setting the auth cookie name! Be sure to call init first!');
    }
};

var instance = new StateContainer();

var index = {
    init: instance.init.bind(instance),
    logout: logout.bind(null, instance),
    checkAuthState: checkAuthState.bind(null, instance),
    getAuthToken: getAuthToken.bind(null, instance)
};

module.exports = index;
